// Offerta e segnaposto da completare prima della pubblicazione.
// I valori tra parentesi quadre sono PLACEHOLDER: sostituirli con i dati reali.

export const CHECKOUT_URL =
  'https://il-sistema-completo-del-coach.impultienda.ar/checkout'

export const PRICE = '€25'
export const REGULAR_PRICE = '€97'
export const SAVINGS = '€72'
export const TOMES_VALUE = '€167'
export const BONUSES_VALUE = '€64'
export const TOTAL_VALUE = '€231'

export const LAUNCH_DEADLINE = '[DATA REALE]'
export const LAUNCH_DEADLINE_NEXT_DAY = '[DATA REALE + 1]'

export const SUPPORT_EMAIL = '[EMAIL SUPPORTO]'
export const SOCIAL_PROFILE = '[PROFILO SOCIAL]'
